/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateCustomerResponse = /* GraphQL */ `
  subscription OnCreateCustomerResponse {
    onCreateCustomerResponse {
      id
      QRCodeBase
      PartyID
      ArrivalDate
      ResidentForm
      ConsentForm
      CurrencyVisitorCrewForm
      CustomerForm
      DeclarationForm
      HealthForm1
      HealthForm2
      HealthForm3
      HealthForm4
      HealthForm5
      HealthForm6
      HealthForm7
      HealthForm8
      PackingList
      ResaleForm
      VisitorSpecificForm
      IntendedResident
      TransitForm
      createdAt
      updatedAt
      agentActions {
        items {
          id
          QRCodeBase
          action
          agent
          userId
          secondary
          location
          createdAt
          updatedAt
        }
        nextToken
      }
      agentComments {
        items {
          id
          QRCodeBase
          PartyID
          agent
          comment
          agentToTraveller
          location
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onUpdateCustomerResponse = /* GraphQL */ `
  subscription OnUpdateCustomerResponse {
    onUpdateCustomerResponse {
      id
      QRCodeBase
      PartyID
      ArrivalDate
      ResidentForm
      ConsentForm
      CurrencyVisitorCrewForm
      CustomerForm
      DeclarationForm
      HealthForm1
      HealthForm2
      HealthForm3
      HealthForm4
      HealthForm5
      HealthForm6
      HealthForm7
      HealthForm8
      PackingList
      ResaleForm
      VisitorSpecificForm
      IntendedResident
      TransitForm
      createdAt
      updatedAt
      agentActions {
        items {
          id
          QRCodeBase
          action
          agent
          userId
          secondary
          location
          createdAt
          updatedAt
        }
        nextToken
      }
      agentComments {
        items {
          id
          QRCodeBase
          PartyID
          agent
          comment
          agentToTraveller
          location
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onDeleteCustomerResponse = /* GraphQL */ `
  subscription OnDeleteCustomerResponse {
    onDeleteCustomerResponse {
      id
      QRCodeBase
      PartyID
      ArrivalDate
      ResidentForm
      ConsentForm
      CurrencyVisitorCrewForm
      CustomerForm
      DeclarationForm
      HealthForm1
      HealthForm2
      HealthForm3
      HealthForm4
      HealthForm5
      HealthForm6
      HealthForm7
      HealthForm8
      PackingList
      ResaleForm
      VisitorSpecificForm
      IntendedResident
      TransitForm
      createdAt
      updatedAt
      agentActions {
        items {
          id
          QRCodeBase
          action
          agent
          userId
          secondary
          location
          createdAt
          updatedAt
        }
        nextToken
      }
      agentComments {
        items {
          id
          QRCodeBase
          PartyID
          agent
          comment
          agentToTraveller
          location
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const onCreateReportExtract = /* GraphQL */ `
  subscription OnCreateReportExtract {
    onCreateReportExtract {
      id
      exportedAt
      user
      userId
      content
      agency
      type
      exportFrom
      exportTo
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateReportExtract = /* GraphQL */ `
  subscription OnUpdateReportExtract {
    onUpdateReportExtract {
      id
      exportedAt
      user
      userId
      content
      agency
      type
      exportFrom
      exportTo
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteReportExtract = /* GraphQL */ `
  subscription OnDeleteReportExtract {
    onDeleteReportExtract {
      id
      exportedAt
      user
      userId
      content
      agency
      type
      exportFrom
      exportTo
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAgentResponse = /* GraphQL */ `
  subscription OnCreateAgentResponse {
    onCreateAgentResponse {
      id
      QRCodeBase
      action
      agent
      userId
      secondary
      location
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAgentResponse = /* GraphQL */ `
  subscription OnUpdateAgentResponse {
    onUpdateAgentResponse {
      id
      QRCodeBase
      action
      agent
      userId
      secondary
      location
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAgentResponse = /* GraphQL */ `
  subscription OnDeleteAgentResponse {
    onDeleteAgentResponse {
      id
      QRCodeBase
      action
      agent
      userId
      secondary
      location
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAgentComment = /* GraphQL */ `
  subscription OnCreateAgentComment {
    onCreateAgentComment {
      id
      QRCodeBase
      PartyID
      agent
      comment
      agentToTraveller
      location
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateAgentComment = /* GraphQL */ `
  subscription OnUpdateAgentComment {
    onUpdateAgentComment {
      id
      QRCodeBase
      PartyID
      agent
      comment
      agentToTraveller
      location
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteAgentComment = /* GraphQL */ `
  subscription OnDeleteAgentComment {
    onDeleteAgentComment {
      id
      QRCodeBase
      PartyID
      agent
      comment
      agentToTraveller
      location
      createdAt
      updatedAt
    }
  }
`;
export const onCreateCode = /* GraphQL */ `
  subscription OnCreateCode {
    onCreateCode {
      id
      code
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateCode = /* GraphQL */ `
  subscription OnUpdateCode {
    onUpdateCode {
      id
      code
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteCode = /* GraphQL */ `
  subscription OnDeleteCode {
    onDeleteCode {
      id
      code
      createdAt
      updatedAt
    }
  }
`;
export const onCreateSecondary = /* GraphQL */ `
  subscription OnCreateSecondary {
    onCreateSecondary {
      id
      number
      text
      active
      codeID
      code {
        id
        code
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateSecondary = /* GraphQL */ `
  subscription OnUpdateSecondary {
    onUpdateSecondary {
      id
      number
      text
      active
      codeID
      code {
        id
        code
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteSecondary = /* GraphQL */ `
  subscription OnDeleteSecondary {
    onDeleteSecondary {
      id
      number
      text
      active
      codeID
      code {
        id
        code
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const onCreateAirline = /* GraphQL */ `
  subscription OnCreateAirline {
    onCreateAirline {
      id
      name
      abbreviation
      active
      createdAt
      updatedAt
      flights {
        items {
          id
          number
          location
          active
          airlineID
          createdAt
          updatedAt
          airline {
            id
            name
            abbreviation
            active
            createdAt
            updatedAt
          }
        }
        nextToken
      }
    }
  }
`;
export const onUpdateAirline = /* GraphQL */ `
  subscription OnUpdateAirline {
    onUpdateAirline {
      id
      name
      abbreviation
      active
      createdAt
      updatedAt
      flights {
        items {
          id
          number
          location
          active
          airlineID
          createdAt
          updatedAt
          airline {
            id
            name
            abbreviation
            active
            createdAt
            updatedAt
          }
        }
        nextToken
      }
    }
  }
`;
export const onDeleteAirline = /* GraphQL */ `
  subscription OnDeleteAirline {
    onDeleteAirline {
      id
      name
      abbreviation
      active
      createdAt
      updatedAt
      flights {
        items {
          id
          number
          location
          active
          airlineID
          createdAt
          updatedAt
          airline {
            id
            name
            abbreviation
            active
            createdAt
            updatedAt
          }
        }
        nextToken
      }
    }
  }
`;
export const onCreateFlight = /* GraphQL */ `
  subscription OnCreateFlight {
    onCreateFlight {
      id
      number
      location
      active
      airlineID
      createdAt
      updatedAt
      airline {
        id
        name
        abbreviation
        active
        createdAt
        updatedAt
        flights {
          items {
            id
            number
            location
            active
            airlineID
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onUpdateFlight = /* GraphQL */ `
  subscription OnUpdateFlight {
    onUpdateFlight {
      id
      number
      location
      active
      airlineID
      createdAt
      updatedAt
      airline {
        id
        name
        abbreviation
        active
        createdAt
        updatedAt
        flights {
          items {
            id
            number
            location
            active
            airlineID
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
export const onDeleteFlight = /* GraphQL */ `
  subscription OnDeleteFlight {
    onDeleteFlight {
      id
      number
      location
      active
      airlineID
      createdAt
      updatedAt
      airline {
        id
        name
        abbreviation
        active
        createdAt
        updatedAt
        flights {
          items {
            id
            number
            location
            active
            airlineID
            createdAt
            updatedAt
          }
          nextToken
        }
      }
    }
  }
`;
